

var _logger = require('xo-beaver/dist/logger');

var _middleware = require('js/lib/middleware');

var _route = require('pages/xo-checkout/route');

var _route2 = _interopRequireDefault(_route);

require('../css/app.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_logger.$logger.info('app_bootstrap', {
    hash: window.location.hash
});

var xoCheckoutRoute = new _route2['default']();

xoCheckoutRoute.bootstrap('checkout.landing', _middleware.$Middleware);

window.bootstrap = true;

_logger.$logger;

_middleware.$Middleware;


//////////////////
// WEBPACK FOOTER
// ./js/app.js
// module id = ./js/app.js
// module chunks = main-code-split